import PropTypes from 'prop-types'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import { FormControl } from 'baseui/form-control'

const ProActivity = ({ hidden, error, isEditable, value, label, options, onChangeHandler, placeholder }) => {
  if (hidden) {
    return null
  }
  return (
    <FormControl error={error}>
      <SDSelect
        label={label}
        disabled={isEditable === false}
        optionsList={options}
        onChangeHandler={onChangeHandler}
        placeholder={placeholder}
        selectedValue={value ? value.toString() : ''}
        hasError={error !== ''}
      />
    </FormControl>
  )
}

ProActivity.propTypes = {
  hidden: PropTypes.bool,
  error: PropTypes.string,
  isEditable: PropTypes.bool,
  value: PropTypes.string,
  onChangeHandler: PropTypes.func,
  label: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  placeholder: PropTypes.string,
}

export default ProActivity
